import type { CompatibilityRedirectVariant } from '@invento/ui';
import { Navigate, useLocation } from 'react-router-dom';

export interface CompatibilityRedirectState {
  compatibilityRedirect: {
    variant: CompatibilityRedirectVariant;
    legacyPath: string;
    fromLabel: string;
    toLabel: string;
  };
}

export function compatibilityRedirectState(
  variant: CompatibilityRedirectVariant,
  legacyPath: string,
  fromLabel: string,
  toLabel: string,
): CompatibilityRedirectState {
  return {
    compatibilityRedirect: { variant, legacyPath, fromLabel, toLabel },
  };
}

export function CompatibilityRedirect({
  to,
  variant,
  toLabel,
}: {
  to: string;
  variant: CompatibilityRedirectVariant;
  toLabel: string;
}) {
  const location = useLocation();
  return (
    <Navigate
      to={`${to}${location.search}${location.hash}`}
      replace
      state={compatibilityRedirectState(variant, location.pathname, location.pathname, toLabel)}
    />
  );
}
